// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text_show {\n  padding-top: 2rem !important;\n}\n.Logo {\n  width: 100%;\n  padding-bottom: 1.6rem;\n  padding-top: 0.853333rem;\n}\n.Logo .img_box {\n  display: flex;\n  justify-content: center;\n}\n.Logo p {\n  font-size: 0.426667rem;\n  line-height: 0.586667rem;\n  color: #333333;\n  text-align: center;\n}\n.Logo img {\n  width: 4.24rem;\n  height: 1.493333rem;\n  padding-top: 0.4rem;\n}", ""]);
// Exports
module.exports = exports;
